import React, { useState } from "react";
import {
    Typography,
    List,
    ListItem,
    Button,
    Collapse, useMediaQuery,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import SubTitle from "../../../../components/elements/SubTitle";
import { useTranslation } from "react-i18next";
import { withStyles } from "@mui/styles";
import { Styles } from "../../../../../config/design/styles";
import { connect } from "trim-redux";
import { Clock } from "lucide-react";
import { ChevronUp, ChevronDown } from 'lucide-react';
import {theme} from "../../../../../config/design/theme";

const VendorHours = ({ timing }) => {
    const { t } = useTranslation();
    const { hours, is_open, next_opening } = timing;
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const [isCollapsed, setIsCollapsed] = useState(false);

    // Helper function to format times (HH:mm)
    const formatTime = (time) => time.slice(0, 5);

    // List all days of the week in order
    const allDays = [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday",
    ];

    // Get today's day
    const today = new Date().toLocaleDateString("en-US", { weekday: "long" });

    // Reorder days: today first, followed by the remaining days in chronological order
    const todayIndex = allDays.indexOf(today);
    const daysOfWeek = [
        ...allDays.slice(todayIndex), // Days from today to the end of the week
        ...allDays.slice(0, todayIndex), // Days from the beginning of the week to the day before today
    ];

    // Determine title content
    const titleContent = is_open ? (
        <strong> {t("openNow")} </strong>
    ) : next_opening ? (
        <>
            {t("closedNow")} {t("opensAt")}{" "}
            <strong>
                {next_opening.day === today
                    ? formatTime(next_opening.time)
                    : `${t(next_opening.day)} ${formatTime(next_opening.time)}`}
            </strong>
        </>
    ) : (
        t("closedNow")
    );

    return (
        <>
            <SubTitle align="left" color="text" style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <Clock />
                <Typography component="span">{titleContent}</Typography>
                <Button
                    size="small"
                    color="text"
                    endIcon={isCollapsed ? <ChevronUp/> : <ChevronDown/>}
                    onClick={() => setIsCollapsed(!isCollapsed)}
                    style={{ marginLeft: "auto" }}
                >
                    {
                        !isMobile &&
                    <Typography style={{fontSize:12}}>{isCollapsed ? t("viewLess") : t("viewMore")}</Typography>
                    }
                </Button>
            </SubTitle>
            <Collapse in={isCollapsed}>
                <List>
                    {daysOfWeek.map((day) => (
                        <ListItem key={day} className="flex-space-important">
                            <Typography
                                variant="body1"
                                sx={{ fontWeight: "bold", minWidth: "100px" }}
                            >
                                {t(day)}:
                            </Typography>
                            {hours[day] && hours[day].length ? (
                                hours[day].map((slot, index) => (
                                    <Typography variant="body2" key={index} sx={{ ml: 1 }}>
                                        {formatTime(slot.open_time)} - {formatTime(slot.close_time)}
                                        {index < hours[day].length - 1 && ","}
                                    </Typography>
                                ))
                            ) : (
                                <Typography variant="body2" sx={{ ml: 1, color: "text.secondary" }}>
                                    {t("closed")}
                                </Typography>
                            )}
                        </ListItem>
                    ))}
                </List>
            </Collapse>
        </>
    );
};

const mstp = (state) => ({
    isAuth: state.isAuth,
    user: state.user,
});

export default withStyles(Styles)(connect(mstp)(VendorHours));
